module.exports = __webpack_public_path__ + "img/images-2.13dcec38.jpg";